import { Loader } from '@googlemaps/js-api-loader'
import mapStyle from './styles.json'
import { handleTooltip } from '../../tools'

// Google Maps Config
const apiOptions = {
    apiKey: process.env.GOOGLE_MAPS_V3_APIKEY,
}

const svgMarker = `
<svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9661_32556)">
<g filter="url(#filter0_d_9661_32556)">
<path d="M15.8646 2C12.8687 2.00244 9.99546 3.16282 7.87252 5.2277C5.74958 7.29257 4.54943 10.0941 4.53418 13.0205C4.53418 17.408 7.05419 21.0815 8.90091 23.7592L9.23755 24.2477C11.0749 26.8489 13.046 29.3575 15.1432 31.7638L15.8742 32.6L16.6052 31.7638C18.7022 29.3573 20.6732 26.8487 22.5109 24.2477L22.8475 23.7498C24.6846 21.0722 27.2046 17.408 27.2046 13.0205C27.1894 10.0925 25.9879 7.28953 23.8629 5.22439C21.7379 3.15925 18.8622 1.99996 15.8646 2Z" fill="#008657"/>
<path d="M15.8646 1L15.8638 1C12.6111 1.00265 9.48711 2.26226 7.17529 4.51086C4.86268 6.76021 3.55085 9.81712 3.53419 13.0153H3.53418V13.0205C3.53418 17.7395 6.22691 21.6435 8.04851 24.2846L8.07747 24.3266L8.07771 24.3269L8.41411 24.8151L8.41406 24.8152L8.42077 24.8247C10.2778 27.4536 12.2699 29.9889 14.3893 32.4209L14.3904 32.422L15.1213 33.2582L15.8742 34.1194L16.6271 33.2582L17.3581 32.422L17.3592 32.4208C19.4783 29.9887 21.4703 27.4535 23.3276 24.8247L23.3335 24.8163L23.3393 24.8078L23.6721 24.3155L23.676 24.3098L23.7339 24.2254C25.5438 21.588 28.2046 17.7108 28.2046 13.0205L28.2046 13.0153C28.1879 9.81534 26.8747 6.75689 24.5598 4.50725C22.2457 2.25837 19.1191 0.999959 15.8646 1Z" stroke="#054F31" stroke-width="2"/>
</g>
</g>
<defs>
<filter id="filter0_d_9661_32556" x="-1.46582" y="0" width="34.6705" height="43.6387" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9661_32556"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9661_32556" result="shape"/>
</filter>
<clipPath id="clip0_9661_32556">
<rect width="32" height="40" fill="white"/>
</clipPath>
</defs>
</svg>    
`;

let map,
    componentBox,
    mapDiv,
    markersProp = {},
    markersList = {}

export function branchesMap() {
    mapDiv = document.querySelector('#branches #branches-map')
    if (!mapDiv) return
    componentBox = document.querySelector('#branches')

    const loader = new Loader(apiOptions)
    loader
        .load()
        .then(() => {
            console.log('Maps JS API loaded')
            buildMarkers(mapDiv)
            handleView()
            handleTooltip(componentBox.querySelectorAll('.branches-view'))
        })
        .catch((e) => console.error('Failed to load map', e))
}

async function buildMarkers(mapDiv) {
    //Build object with markers initial properties
    // const endpoint = `${process.env.BASE_URL}/api/core/dealers/`;
    // const branchesData = await fetch(endpoint, {
    //     method: "GET",
    //     headers: {
    //         "Content-Type": "application/json",
    //     },
    // })
    //     .then(function (response) {
    //         if (!response.ok) {
    //             throw new Error("Error al obtener dealers");
    //         }
    //         return response.json();
    //     })
    //     .catch(function (error) {
    //         console.error(error);
    //     });

    // BRANCHES_DATA is passed by context
    for (const branch of window.BRANCHES_DATA) {
        const categories = branch.services?.map(function (service) {
            return service.id
        })
        const categoryNames = branch.services?.map(function (service) {
            return service.name
        })

        if (branch.latitude && branch.longitude) {
            markersProp[`marker_${branch.id}`] = {
                position: {
                    lat: parseFloat(branch.latitude),
                    lng: parseFloat(branch.longitude),
                },
                categories,
                categoryNames,
                visible: true,
                title: branch.title || '',
                subtitle: branch.subtitle || '',
                address: branch.address || '',
                state: branch.state || '',
                telephone: branch.phone_numbers || '',
                email: branch.email || '',
                gmb_link: branch.google_my_business_link || '',
            }
        }
    }

    loadMap(mapDiv)
}

function loadMap(mapDiv) {
    // Config inicial
    const mapOptions = {
        center: {
            lat: -39.7586041,
            lng: -61.1353059,
        },
        zoom: 4,
        minZoom: 3,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        styles: mapStyle,
    }

    // Instancia mapa
    map = new google.maps.Map(mapDiv, mapOptions)
    // Set markers

    for (const key in markersProp) {
        if (markersProp.hasOwnProperty(key)) {
            markersList[key] = new google.maps.Marker({
                map,
                position: markersProp[key].position,
                icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgMarker),
                optimized: true,
                categories: markersProp[key].categories,
                visible: markersProp[key].visible,
                data: markersProp[key],
            })

            markersList[key].addListener('click', function () {
                map.panTo(this.getPosition())
                smoothZoom(15, map.getZoom())
                showInfo(this.data)
            })
        }
    }

    // Filtro de lugar
    const selectLocations = componentBox.querySelectorAll('select.location')
    selectLocations.forEach((selectLocation) => {
        selectLocation.addEventListener('change', function (e) {
            // Center map
            let id = this.value
            let location = this.options[this.selectedIndex].textContent
            let country = this.getAttribute('data-country')

            // Populate next
            if (this.getAttribute('name') === 'countries') {
                getStates(this.value, location)
                // Filtrar la lista de sucursales
                const statesSelect = componentBox.querySelector('select.location[name="states"]')
                statesSelect.disabled = true
                filterByLocation('country', id)
            } else if (this.getAttribute('name') == 'states') {
                if (location != 'Ciudad Autónoma de Buenos Aires') {
                    location = 'Provincia de ' + location + ', ' + country
                }

                // Filter branches list
                filterByLocation('state', id, country)
            }

            const geocoder = new google.maps.Geocoder()
            geocoder.geocode({ address: location }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()))
                    map.fitBounds(results[0].geometry.viewport)
                }
            })

            // Hide infobox
            const infoElement = componentBox.querySelector('.branches-map-info')
            hide(infoElement)
        })
    })

    // Filtro de categorias
    const catCheckboxes = componentBox.querySelectorAll('.cat_checks')
    catCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            let selected = []
            const checkedCheckboxes = componentBox.querySelectorAll('.cat_checks:checked')
            checkedCheckboxes.forEach(function (checkedCheckbox) {
                if (checkedCheckbox.value) {
                    selected.push(parseInt(checkedCheckbox.value))
                }
            })

            for (const key in markersProp) {
                if (markersProp.hasOwnProperty(key)) {
                    if (arrayMatch(selected, markersList[key].categories)) {
                        markersList[key].setVisible(true)
                    } else {
                        markersList[key].setVisible(false)
                    }
                }
            }

            filterByCategory()

            // Hide infobox
            const infoElement = componentBox.querySelector('.branches-map-info')
            hide(infoElement)
        })
    })
    filterByCategory()
}

function getStates(id, countryName) {
    const endpoint = `${process.env.BASE_URL}/api/core/states/?country=${id}&has_dealers=True`
    const selectEl = componentBox.querySelector('select[name="states"]')
    selectEl.dataset.country = id
    selectEl.setAttribute('disabled', '')

    fetch(endpoint, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Error al obtener las provincias')
            }
            return response.json()
        })
        .then(function (states) {
            let opt = `<option value="" selected>Todas</option>`

            if (states.length > 0) {
                states.forEach((state) => {
                    opt += `
                    <option value="${state.id}">${state.name}</option>
                `
                })
                selectEl.innerHTML = opt
                selectEl.removeAttribute('disabled')
            }
        })
        .catch(function (error) {
            console.error(error)
        })
}

function filterByLocation(type, id, countryId) {
    const branchElements = componentBox.querySelectorAll('.branch-list-map .branch-list>li')
    let filteredElements
    if (id) {
        branchElements.forEach((element) => {
            element.classList.add('hidden-location')
        })

        filteredElements = componentBox.querySelectorAll(`.branch-list-map .branch-list>li[data-${type}="${id}"]`)

        filteredElements.forEach((element) => {
            element.classList.remove('hidden-location')
        })
    } else {
        if (type === 'state') {
            filteredElements = componentBox.querySelectorAll(`.branch-list-map .branch-list>li[data-country="${countryId}"]`)
            filteredElements.forEach((element) => {
                element.classList.remove('hidden-location')
            })
        } else {
            document.querySelectorAll('.branch-list-map .branch-list>li.hidden-location').forEach((element) => {
                element.classList.remove('hidden-location')
            })
        }
    }

    filterByCategory()
}

function filterByCategory() {
    const branchListItems = componentBox.querySelectorAll('.branch-list-map .branch-list>li')
    branchListItems.forEach(function (item) {
        const itemType = item.getAttribute('data-type')
        if (itemType) {
            setBranchVisibility(item)
        }
    })
    emptyBranchesMsg()
}

function setBranchVisibility(item) {
    const branchTypes = Array.from(componentBox.querySelectorAll('.cat_checks:checked')).map(function (checkbox) {
        return checkbox.value
    })

    const commonTypes = Array.from(item.getAttribute('data-type').split(' ')).filter(function (type) {
        return branchTypes.includes(type)
    })

    if (!item.classList.contains('hidden-category')) {
        if (commonTypes.length === 0) {
            item.classList.add('hidden-category')
        } else {
            item.classList.remove('hidden-category')
        }
    } else {
        if (commonTypes.length > 0) {
            item.classList.remove('hidden-category')
        }
    }
}

function smoothZoom(max, cnt) {
    if (cnt >= max) {
        return
    } else {
        const z = google.maps.event.addListener(map, 'zoom_changed', function (event) {
            google.maps.event.removeListener(z)
            smoothZoom(map, max, cnt + 1)
        })
        setTimeout(function () {
            map.setZoom(cnt)
        }, 100)
    }
}

function handleView() {
    let currentView = 'grid'
    const branchesView = componentBox.querySelectorAll('.branches-view')
    branchesView.forEach((btn) => {
        btn.addEventListener('click', function () {
            const view = btn.getAttribute('data-view')
            const mapView = componentBox.querySelector('.view.map')
            const gridView = componentBox.querySelector('.view.grid')

            if (view !== currentView) {
                const headerViewsBtns = componentBox.querySelectorAll('.header-views button')
                headerViewsBtns.forEach((btn) => {
                    btn.classList.remove('active')
                })
                btn.classList.add('active')
                currentView = view

                if (view === 'grid') {
                    mapView.classList.add('hidden-map')
                    show(gridView)
                }
                if (view === 'map') {
                    mapView.classList.remove('hidden-map')
                    hide(gridView)
                }
            }
        })
    })
}

function showInfo(info) {
    const infoElement = componentBox.querySelector('.branches-map-info')
    const titleElement = infoElement.querySelector('.branches-map-info__title')
    const subtitleElement = infoElement.querySelector('.branches-map-info__subtitle')
    const addressElement = infoElement.querySelector('.branches-map-info__address')
    const stateElement = infoElement.querySelector('.branches-map-info__state')
    const telephoneElement = infoElement.querySelector('.branches-map-info__telephone')
    const emailElement = infoElement.querySelector('.branches-map-info__email a')
    const categoriesElement = infoElement.querySelector('.branches-map-info__categories')

    titleElement.textContent = info.title
    subtitleElement.textContent = info.subtitle
    addressElement.textContent = info.address
    stateElement.textContent = info.state
    telephoneElement.textContent = info.telephone
    emailElement.textContent = info.email
    emailElement.setAttribute('href', `mailto:${info.email}`)
    categoriesElement.innerHTML = ''

    info.categoryNames.forEach((cat) => {
        const categoryElement = `
        <li class="branches-map-info__category">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="#EBF8F3"/><path d="M14 6.78467L8.5 12.2847L6 9.78467" stroke="#008657" stroke-linecap="round" stroke-linejoin="round"/></svg>
            ${cat}
        </li>
        `
        categoriesElement.innerHTML += categoryElement
    })

    if (!infoElement.style.display || infoElement.style.display === 'none') {
        show(infoElement)
    }

    const closeButton = infoElement.querySelector('button.close')
    closeButton.addEventListener('click', () => {
        hide(infoElement)
    })
}

function show(element, display = 'block') {
    element.style.display = display
}

function hide(element) {
    element.style.display = 'none'
}

function emptyBranchesMsg() {
    const branches = [...componentBox.querySelectorAll('.branch-list-map .branch-list>li')]
    const emptyMsg = componentBox.querySelector('.branch-list-empty')
    const argBlock = componentBox.querySelector('#branch-list-arg')
    const othersBlock = componentBox.querySelector('#branch-list-others')

    const allBranchesAreEmpty = branches.every((branch) => branch.classList.contains('hidden-location') || branch.classList.contains('hidden-category'))

    if (allBranchesAreEmpty) {
        emptyMsg.style.display = 'block'
        argBlock.style.display = 'none'
        othersBlock.style.display = 'none'
    } else {
        emptyMsg.style.display = 'none'
        hideArgBlock(argBlock)
        hideOthersBlock(othersBlock)
    }
}

function hideArgBlock(argBlock) {
    const argBranches = [...argBlock.querySelectorAll('.branch-list>li')]

    const allBranchesAreEmpty = argBranches.every((branch) => branch.classList.contains('hidden-location') || branch.classList.contains('hidden-category'))

    allBranchesAreEmpty ? (argBlock.style.display = 'none') : (argBlock.style.display = 'block')
}

function hideOthersBlock(othersBlock) {
    const othersBranches = [...othersBlock.querySelectorAll('.branch-list>li')]

    const allBranchesAreEmpty = othersBranches.every((branch) => branch.classList.contains('hidden-location') || branch.classList.contains('hidden-category'))

    allBranchesAreEmpty ? (othersBlock.style.display = 'none') : (othersBlock.style.display = 'block')
}

//Compare two arrays
function arrayMatch(arr1, arr2) {
    var ret = []
    arr1.sort()
    arr2.sort()
    for (var i = 0; i < arr1.length; i += 1) {
        if (arr2.indexOf(arr1[i]) > -1) {
            ret.push(arr1[i])
        }
    }
    if (ret.length > 0) {
        return true
    } else {
        return false
    }
}
